import React from 'react';
import { Button } from 'react-bootstrap';
import FlagCasePopUp from 'areas/admin/certification/shared/FlagCasePopUp';

class AppReviewToolbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            showFlagCasePopUp: false
        };
    }

    showFlagCasePopUp = () => {
        this.setState({
            showFlagCasePopUp: true
        });
    }

    handleFlagCase = () => {
        const me = this;
        me.showFlagCasePopUp();
    }

    onFlagCaseClose = () => {
        this.setState({
            showFlagCasePopUp: false
        });
    }

    onFlagSave = (flagForm, savedEntity) => {
        let comments = null;
        let savedComment = savedEntity.comment;
        if (this.props.comments)
            comments = this.props.comments;
        else
            comments = []

        if (comments) {
            comments.unshift({
                commentId: savedComment.commentId,
                reviewTypeDescription: savedComment.reviewTypeDescription,
                queueTypeDescription: savedComment.queueTypeDescription,
                commentTypeCode: savedComment.commentTypeCode,
                content: savedComment.content,
                addedDate: savedComment.addedAt,
                addedBy: savedComment.addedBy
            });
        }

        this.props.onFlagSave(comments, savedEntity.canCompleteReview);
    }

    render() {
        return (
            <React.Fragment>
                <Button id="btnFlagCase"
                    bsStyle="default"
                    className="btn-block"
                    onClick={this.handleFlagCase}
                    disabled={this.props.disabled}>
                    Flag Case
                </Button>
                <FlagCasePopUp
                    certificationKey={this.props.certificationKey}
                    queueTypeCode={this.props.queueTypeCode}
                    reviewTypeCode={this.props.reviewTypeCode}
                    visible={this.state.showFlagCasePopUp}
                    onClose={this.onFlagCaseClose}
                    onSave={(form, savedEntity) => { this.onFlagSave(form, savedEntity) }} />
            </React.Fragment>
        );
    }
}

// Default properties
AppReviewToolbar.defaultProps = {
    disabled: false
}

export default AppReviewToolbar;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/AppReviewToolbar.js